import { IChatServerService } from '@/app-modules/server-service';
import { ChatContextMenuModule } from '@/components/chat/_domain/modules/chat-context-menu/chat-context-menu';
import { injectable } from 'inversify';
import { ILocalisationService } from '@/app-modules/localisation-service';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IUserProfileService } from '@/components/chat/_domain/modules/user-profile-service';
import { ISinBanService } from '@/components/chat/_domain/modules/sin-ban-service';
import { IChatPrizeService } from '@/components/chat/_domain/modules/chat-prize-service';
import { ISafeplayService } from '@/components/chat/_domain/modules/safeplay-service';
import { ITechnicalIssueService } from '@/components/chat/_domain/modules/technical-issue-service';
import { IUserNominationService } from '@/components/chat/_domain/modules/user-nomination-service';

interface IChatContextMenuFactory {
  createChatContextMenuModule(chatServerService: IChatServerService): ChatContextMenuModule;
}

@injectable()
class ChatContextMenuFactory implements IChatContextMenuFactory {
  public createChatContextMenuModule(chatServerService: IChatServerService): ChatContextMenuModule {
    const localisationService: ILocalisationService = container.get(SERVICE_IDENTIFIERS.ILocalisationService);
    const userProfileService: IUserProfileService = container.get(SERVICE_IDENTIFIERS.IUserProfileService);
    const sinBanService: ISinBanService = container.get(SERVICE_IDENTIFIERS.ISinBanService);
    const chatPrizeService: IChatPrizeService = container.get(SERVICE_IDENTIFIERS.IChatPrizeService);
    const safeplayService: ISafeplayService = container.get(SERVICE_IDENTIFIERS.ISafeplayService);
    const techincalIssueService: ITechnicalIssueService = container.get(SERVICE_IDENTIFIERS.ITechicalIssueService);
    const userNominationService: IUserNominationService = container.get(SERVICE_IDENTIFIERS.IUserNominationService);
    return new ChatContextMenuModule(chatServerService, localisationService, userProfileService, sinBanService, chatPrizeService, safeplayService, techincalIssueService, userNominationService);
  }
}

export { IChatContextMenuFactory, ChatContextMenuFactory };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/chat-context-menu/chat-context-menu-factory.ts